import { useState } from 'react';
import { SECTION_COLOR, SECTION_BG } from './lide';

/** Fotka zaměstnance, nebo iniciály v barvě sekce. */
export default function Avatar({ z, size = 32 }) {
    const [chyba, setChyba] = useState(false);
    const url = z.avatar_url_resolved;
    if (url && !chyba) {
        return (
            <img src={url} alt="" onError={() => setChyba(true)}
                style={{
                    width: size, height: size, borderRadius: '50%', objectFit: 'cover',
                    objectPosition: z.avatar_position || 'center center', flexShrink: 0,
                }} />
        );
    }
    return (
        <div style={{
            width: size, height: size, borderRadius: '50%', background: SECTION_BG, color: SECTION_COLOR,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: Math.round(size * 0.36), fontWeight: 700, flexShrink: 0,
        }}>
            {z.jmeno?.[0]}{z.prijmeni?.[0]}
        </div>
    );
}
